import { Navbar, Container, Button, Row, Col } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import { LogOut } from "lucide-react"

import { useLogoutUserMutation } from "../../../../app/authApiSlice"
import useAuth from "../../../../hooks/useAuth"
import GBLogo from "../../../../assets/GB.png"

const Header = () => {
  const { email, role } = useAuth()
  const [logoutUser] = useLogoutUserMutation()

  const onLogoutClicked = () => {
    logoutUser()
  }

  return (
    <Navbar className="shadow-sm bg-white position-fixed w-100" style={{ zIndex: "9999" }}>
      <Container fluid className="px-sm-5 ps-3 w-100">
        <Row className="w-100 m-0">
          <Col xs={4} className="d-flex align-items-center d-lg-none p-0">
          </Col>
          <Col lg={1} xs={4} className="d-flex justify-content-center justify-content-lg-start p-0">
            <LinkContainer className="" to={`/${role}`}>
              <Navbar.Brand><img src={GBLogo} style={{ width: "5rem", height: "auto" }} alt="Logo" /></Navbar.Brand>
            </LinkContainer>
          </Col>
          <Col lg={11} xs={4} className="d-flex align-items-center justify-content-end p-0">
            <div className="d-flex gap-md-2 gap-lg-3 align-items-center w-100 justify-content-end h-100">
              <Navbar.Text className="fw-bold d-none d-md-block">
                {email || "Unknown"}
              </Navbar.Text>
              <Button
                variant="link"
                className="px-lg-4 text-muted rounded-3 custom-hover"
                onClick={onLogoutClicked}
                style={{ height: "40px" }}
              >
                <LogOut />
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  )
}
export default Header